var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stat-card"},[_c('div',[_c('p',{staticClass:"stat-label"},[_vm._v(_vm._s(_vm.label))]),_c('p',{staticClass:"stat-value"},[_vm._v(_vm._s(_vm.value))])]),_c('div',{staticClass:"stat-icon",style:({ background: _vm.color + '18' })},[_vm._v(_vm._s(_vm.icon))])])
}
var staticRenderFns = []

export { render, staticRenderFns }